<div
  class="profile"
  [class.is-collapsed]="collapsed()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <button
    #menuTrigger
    class="profile__trigger"
    type="button"
    aria-label="User menu"
    aria-controls="layout-profile-menu"
    [attr.aria-expanded]="menuOpen()"
    (click)="toggleMenu($event)"
  >
    <span class="profile__avatar">
      @if (model().avatarUrl; as avatarUrl) {
        <img
          class="profile__avatar-image"
          [src]="avatarUrl"
          [alt]="model().displayName + ' avatar'"
          loading="lazy"
          referrerpolicy="no-referrer"
        />
      } @else {
        {{ model().initials }}
      }
    </span>
    <span class="profile__summary">
      <span class="profile__name">{{ model().displayName }}</span>
      <span class="profile__workspace">{{ model().workspaceLabel }}</span>
    </span>
    <i
      sch-icon="more-vertical-fill"
      class="profile__more"
      aria-hidden="true"
    ></i>
  </button>

  @if (menuOpen()) {
    <nav #menu id="layout-profile-menu" class="profile__menu" aria-label="User">
      <header class="profile__menu-header">
        <span class="profile__menu-name">{{ model().displayName }}</span>
        <span class="profile__menu-context">{{ model().contextLabel }}</span>
      </header>
      <span class="profile__divider" aria-hidden="true"></span>
      @for (item of model().navigation; track item.route) {
        <a
          class="profile__menu-link"
          [class.is-active]="item.isActive"
          [attr.aria-current]="item.isActive ? 'page' : null"
          [href]="item.route"
          (click)="requestNavigation($event, item)"
        >
          @if (item.icon) {
            <i [sch-icon]="item.icon" aria-hidden="true"></i>
          }
          <span>{{ item.label }}</span>
        </a>
      }
      <span class="profile__divider" aria-hidden="true"></span>
      <a
        class="profile__menu-link profile__menu-link--danger"
        href="/logout"
        (click)="requestSignOut($event)"
      >
        <i sch-icon="logout" aria-hidden="true"></i>
        <span>Sign out</span>
      </a>
    </nav>
  }
</div>
